import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {Row, Col, FormGroup} from 'reactstrap';
import DatePicker from "react-datepicker";
import SelectFormGroup from "components/NonFormsyForm/SelectFormGroup";
import 'react-datepicker/dist/react-datepicker.css';

class Total extends React.Component {
    static propTypes = {
        dateFrom: PropTypes.object.isRequired,
        dateTo: PropTypes.object.isRequired,
        adId: PropTypes.string.isRequired,
        ads: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        })).isRequired,
        onChangeDateFrom: PropTypes.func.isRequired,
        onChangeDateTo: PropTypes.func.isRequired,
        onChangeOperatorAd: PropTypes.func.isRequired,
        loading: PropTypes.bool,
    };

    render() {
        const {dateFrom, dateTo, adId, ads, onChangeDateFrom, onChangeDateTo, onChangeOperatorAd} = this.props;

        return (
            <div className="stats__filter">
                <h5><FormattedMessage id="stats.time_interval" defaultMessage="Time interval"/></h5>
                <Row className="form-row">
                    <Col>
                        <FormGroup>
                            <DatePicker className="form-control datepicker" dateFormat="LL" id="date_from"
                                        onChange={onChangeDateFrom} selected={dateFrom}/>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <DatePicker className="form-control datepicker" dateFormat="LL" id="date_to"
                                        onChange={onChangeDateTo} selected={dateTo}/>
                        </FormGroup>
                    </Col>
                </Row>
                <h5><FormattedMessage id="stats.ad" defaultMessage="Ad"/></h5>
                <SelectFormGroup id="operatorAds" name="operatorAds" values={ads} setValue={onChangeOperatorAd} valueSelected={adId} />
                <FormGroup/>
            </div>
        )
    }
}

export default Total;


// WEBPACK FOOTER //
// ./src/containers/Stats/Filter.jsx